// Dev-only helper to force API calls to fail, so error states can be inspected.
//
// Enable from the browser console:
//   breadgptForceErrors('all')          -> every API call fails
//   breadgptForceErrors('/chats')       -> only URLs containing "/chats" fail
//   breadgptForceErrors('/users,/roles')-> multiple substrings (comma-separated)
//   breadgptForceErrors(null)           -> turn off
// It is off unless the flag is explicitly set, and never affects real users.

const KEY = 'breadgpt_force_errors'

export function shouldForceError(url?: string): boolean {
  try {
    const v = localStorage.getItem(KEY)
    if (!v) return false
    if (v === 'all') return true
    return v
      .split(',')
      .map(s => s.trim())
      .some(s => s && (url || '').includes(s))
  } catch {
    return false
  }
}

// An axios-error-shaped object so error handlers that read `response.data.detail`
// show a realistic message.
export function forcedError() {
  return {
    isForcedError: true,
    message: 'Forced error (dev)',
    response: {
      status: 500,
      data: { detail: 'Forced error — this is what a failure looks like.' },
    },
  }
}

// Expose the console toggle.
;(window as unknown as Record<string, unknown>).breadgptForceErrors = (
  patternOrNull: string | null
) => {
  if (patternOrNull) localStorage.setItem(KEY, patternOrNull)
  else localStorage.removeItem(KEY)
  return `force-errors = ${localStorage.getItem(KEY) ?? '(off)'}`
}
